<div class="news-editor">
  <!-- Área de notificaciones -->
  <div class="notification-area" *ngIf="notification">
    <div class="alert" [ngClass]="'alert-' + notification.type" role="alert">
      {{ notification.message }}
      <button type="button" class="btn-close" (click)="clearNotification()"></button>
    </div>
  </div>

  <!-- Mensajes de carga y estado -->
  <div class="loading-message" *ngIf="showLoadingMessage">
    <div class="alert"
      [ngClass]="{'alert-info': !tipoMensaje, 'alert-success': tipoMensaje === 'success', 'alert-danger': tipoMensaje === 'error'}"
      role="alert">
      {{ mensaje }}
    </div>
  </div>
  <!-- Barra superior -->
  <nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm mb-4">
    <div class="container-fluid px-4">
      <div class="navbar-brand mb-0 h1">Editor de Noticias</div>
      <div class="d-flex align-items-center">
        <!-- Información del usuario -->
        <div class="d-flex flex-column align-items-end me-4">
          <div class="d-flex align-items-center">
            <span class="fw-medium">{{ currentUser?.name }}</span>
            <span class="mx-2 text-muted">|</span>
            <span class="badge" [ngClass]="{
            'bg-primary': currentUser?.role === 'admin',
            'bg-success': currentUser?.role === 'editor',
            'bg-warning': currentUser?.role === 'general_editor'
          }">{{ 
            currentUser?.role === 'editor' ? 'Editor de Ciudad' : 
            currentUser?.role === 'admin' ? 'Administrador' : 
            currentUser?.role === 'general_editor' ? 'Editor General' : currentUser?.role 
          }}</span>
          </div>
          <small class="text-muted">{{ currentUser?.email }}</small>
        </div>
        <!-- Botón de cerrar sesión -->
        <button (click)="logout()" class="btn btn-outline-danger btn-sm">
          <i class="bi bi-box-arrow-right me-1"></i>
          Cerrar Sesión
        </button>
      </div>
    </div>
  </nav>

  <div class="row">
    <!-- Sidebar con lista de artículos -->
    <div class="col-md-3 sidebar">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4>Artículos</h4>
        <button class="btn btn-primary" (click)="createNewArticle()">
          <i class="bi bi-plus-lg"></i> Nuevo
        </button>
      </div>

      <div class="articles-list">
        <div class="form-group mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <i class="bi bi-search"></i>
            </span>
            <input type="text" class="form-control" placeholder="Buscar artículos..." [(ngModel)]="searchTerm"
              (ngModelChange)="filterArticles()">
          </div>
        </div>

        <div class="list-group">
          <button *ngFor="let article of filteredArticles" 
                  (click)="selectArticle(article)"
                  class="list-group-item list-group-item-action d-flex flex-column"
                  [class.active]="currentArticle?.id === article.id">
            <div class="d-flex w-100 justify-content-between align-items-start">
              <div class="ms-2 me-auto">
                <div class="fw-bold">{{ article.title }}</div>
                <small class="text-muted">{{ article.lastModified | date:'dd/MM/yyyy' }}</small>
              </div>
              <span class="badge rounded-pill" [ngClass]="{
                'bg-success': article.status === 'published',
                'bg-secondary': article.status === 'draft'
              }">
                {{ article.status === 'published' ? 'Publicado' : 'Borrador' }}
              </span>
            </div>
            <div class="ms-2">
              <small class="text-muted">
                Autor: {{ article.author }}
                <span *ngIf="article.authorId === currentUser?.id" class="badge bg-info ms-2">Tú</span>
              </small>
            </div>
          </button>
        </div>
      </div>
    </div>

    <!-- Editor principal -->
    <div class="col-md-9 main-editor">
      <!-- Vista previa -->
      <div *ngIf="previewMode" class="preview-container">
        <div class="editor-header d-flex justify-content-between align-items-center mb-4">
          <h2>Vista Previa</h2>
          <div class="btn-group">
            <button class="btn btn-outline-secondary" (click)="togglePreview()">
              <i class="bi bi-pencil"></i> Volver al Editor
            </button>
          </div>
        </div>
        <app-news-viewer [article]="currentArticle" [previewMode]="true"></app-news-viewer>
      </div>

      <!-- Editor -->
      <div *ngIf="!previewMode">
        <div class="editor-header d-flex justify-content-between align-items-center mb-4">
          <div>
            <h2 *ngIf="!currentArticle?.id">Nuevo Artículo</h2>
            <h2 *ngIf="currentArticle?.id">Editando Artículo</h2>
          </div>
          <div class="btn-group">
            <button class="btn btn-outline-secondary" (click)="togglePreview()">
              <i class="bi bi-eye"></i> Vista Previa
            </button>
            <button class="btn btn-outline-secondary" (click)="cancelEdit()">
              <i class="bi bi-x-lg"></i> Cancelar
            </button>
            <!-- Botón Eliminar (solo visible si se edita un artículo existente) -->
            <button *ngIf="currentArticle" class="btn btn-danger" (click)="deleteCurrentArticle()">
              <i class="bi bi-trash"></i> Eliminar
            </button>
            <button class="btn btn-primary" (click)="saveArticle()" [disabled]="isUploading">
              <i class="bi bi-save"></i> Guardar {{ isUploading ? '(Subiendo...)' : '' }}
            </button>
          </div>
        </div>

        <form [formGroup]="articleForm" class="editor-form">
          <div class="row">
            <div class="col-md-8">
              <!-- Título y contenido principal -->
              <div class="form-group mb-3">
                <label for="articleTitle" class="form-label">Título del artículo</label>
                <input type="text" id="articleTitle" class="form-control form-control-lg"
                  [ngClass]="{'is-invalid': articleForm.get('title')?.invalid && articleForm.get('title')?.touched}"
                  formControlName="title"
                  placeholder="Ingrese el título">
                <div class="invalid-feedback"
                  *ngIf="articleForm.get('title')?.errors?.['required'] && articleForm.get('title')?.touched">
                  El título es requerido
                </div>
                <div class="invalid-feedback"
                  *ngIf="articleForm.get('title')?.errors?.['minlength'] && articleForm.get('title')?.touched">
                  El título debe tener al menos 5 caracteres
                </div>
              </div>

              <div class="form-group mb-3">
                <label for="articleSubtitle" class="form-label">Bajada (opcional)</label>
                <input type="text" id="articleSubtitle" class="form-control"
                  [ngClass]="{'is-invalid': articleForm.get('subtitle')?.invalid && articleForm.get('subtitle')?.touched}"
                  formControlName="subtitle"
                  placeholder="Ingrese la bajada">
              </div>

              <div class="form-group mb-4">
                <label class="form-label">Contenido del artículo</label>
                <div formArrayName="paragraphs">
                  <div *ngFor="let paragraph of paragraphsArray.controls; let i = index" [formGroupName]="i"
                    class="paragraph-container mb-4">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <label class="form-label mb-0">Párrafo {{i + 1}}</label>
                      <div class="btn-group">
                        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="moveParagraph(i, 'up')"
                          [disabled]="i === 0">
                          <i class="bi bi-arrow-up"></i>
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-secondary"
                          (click)="moveParagraph(i, 'down')" [disabled]="i === paragraphsArray.length - 1">
                          <i class="bi bi-arrow-down"></i>
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeParagraph(i)">
                          <i class="bi bi-trash"></i>
                        </button>
                      </div>
                    </div>

                    <div class="mb-3">
                      <!-- Input para el título del párrafo -->
                      <input type="text" class="form-control mb-2"
                        [ngClass]="{'is-invalid': paragraph.get('title')?.invalid && paragraph.get('title')?.touched}"
                        placeholder="Título del párrafo (opcional)" formControlName="title">
                      <editor
                        apiKey="8dg3l0xydd4tl812e3mbj0x9mrgmll4tzovl9buxql2hfucz"
                        [init]="editorConfig"
                        [formControlName]="'content'"
                        class="form-control"
                        style="min-height: 200px;">
                      </editor>
                      <small class="text-muted" style="display: flex; justify-content: center;">Para salto de línea simple usa <kbd style="margin-left: 4px;">Shift + Enter</kbd>.</small>
                    </div>

                    <div class="image-upload-container mb-3">
                      <!-- Barra de progreso de carga -->
                      <div class="upload-progress mb-3" *ngIf="isUploading && uploadingImageType === 'paragraph'">
                        <div class="progress">
                          <div class="progress-bar" role="progressbar" 
                               [style.width.%]="uploadProgress"
                               [attr.aria-valuenow]="uploadProgress" 
                               aria-valuemin="0" 
                               aria-valuemax="100">
                            {{uploadProgress}}%
                          </div>
                        </div>
                      </div>

                      <div class="image-preview" *ngIf="paragraph.get('imagePreview')?.value || paragraph.get('imageUrl')?.value">
                        <img [src]="paragraph.get('imagePreview')?.value || paragraph.get('imageUrl')?.value" alt="Vista previa" class="img-fluid mb-2"
                          style="max-height: 150px; width: auto;">
                        <div class="form-group mt-2">
                          <input type="text" class="form-control" placeholder="Agregar pie de imagen"
                            [ngClass]="{'is-invalid': paragraph.get('imageCaption')?.invalid && paragraph.get('imageCaption')?.touched}"
                            [formControlName]="'imageCaption'">
                        </div>
                        <button type="button" class="btn btn-sm btn-danger mt-2" (click)="removeParagraphImage(i)">
                          <i class="bi bi-trash"></i> Eliminar imagen
                        </button>
                      </div>

                      <button type="button" class="btn btn-sm btn-outline-secondary"
                        *ngIf="!paragraph.get('imagePreview')?.value && !paragraph.get('imageUrl')?.value"
                        (click)="selectPosition(i); contentImageInput.click()">
                        <i class="bi bi-image"></i> Agregar imagen
                      </button>
                    </div>

                    <!-- Sección para agregar video -->
                    <div class="video-upload-container mb-3">
                      <label class="form-label">Video</label>
                      <div class="input-group mb-2">
                        <span class="input-group-text"><i class="bi bi-film"></i></span>
                        <input type="text" class="form-control" placeholder="URL del video (YouTube)"
                          [ngClass]="{'is-invalid': paragraph.get('urlVideo')?.invalid && paragraph.get('urlVideo')?.touched}"
                          [formControlName]="'urlVideo'">
                      </div>
                      
                      <div class="video-preview" *ngIf="paragraph.get('urlVideo')?.value">
                        <!-- Vista previa de YouTube -->
                        <div *ngIf="isYouTubeUrl(paragraph.get('urlVideo')?.value)" class="ratio ratio-16x9 mb-2">
                          <iframe [src]="previewVideo(paragraph.get('urlVideo')?.value) | safe" 
                                  frameborder="0"
                                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                  allowfullscreen></iframe>
                        </div>
                        <!-- Vista previa de Facebook -->
                        <div *ngIf="isFacebookUrl(paragraph.get('urlVideo')?.value)" class="ratio ratio-16x9 mb-2">
                          <iframe [src]="previewVideo(paragraph.get('urlVideo')?.value) | safe" 
                                  frameborder="0" allowfullscreen></iframe>
                        </div>
                        <!-- Mensaje para otras plataformas -->
                        <div *ngIf="!isYouTubeUrl(paragraph.get('urlVideo')?.value) && !isFacebookUrl(paragraph.get('urlVideo')?.value)" 
                             class="alert alert-info">
                          <i class="bi bi-info-circle"></i> Video añadido: {{paragraph.get('urlVideo')?.value}}
                        </div>
                        <!-- Pie de video -->
                        <div class="form-group mb-2" *ngIf="paragraph.get('urlVideo')?.value">
                          <input type="text" class="form-control" placeholder="Pie de video"
                            [formControlName]="'pieDeVideo'">
                        </div>
                        <!-- Botón para eliminar video -->
                        <button type="button" class="btn btn-sm btn-danger mt-2" (click)="removeParagraphVideo(i)">
                          <i class="bi bi-trash"></i> Eliminar video
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <button type="button" class="btn btn-outline-primary" (click)="addParagraph()">
                  <i class="bi bi-plus-lg"></i> Agregar párrafo
                </button>
              </div>
            </div>

            <div class="col-md-4">
              <!-- Panel lateral de configuración -->
              <div class="config-panel">
                <h5 class="mb-3">Configuración del artículo</h5>

                <!-- Imagen principal -->
                <div class="form-group mb-4">
                  <label class="form-label">Imagen principal</label>
                  <div class="image-upload-container">
                    <input type="file" #imageInput class="form-control" accept="image/*" 
                           (change)="onImageSelected($event)" [style.display]="'none'">
                    
                    <!-- Barra de progreso de carga -->
                    <div class="upload-progress mb-3" *ngIf="isUploading && uploadingImageType === 'main'">
                      <div class="progress">
                        <div class="progress-bar" role="progressbar" 
                             [style.width.%]="uploadProgress"
                             [attr.aria-valuenow]="uploadProgress" 
                             aria-valuemin="0" 
                             aria-valuemax="100">
                          {{uploadProgress}}%
                        </div>
                      </div>
                    </div>

                    <!-- Preview de imagen principal -->
                    <div class="image-preview mb-3" *ngIf="articleForm.get('imagePreview')?.value || articleForm.get('imageUrl')?.value">
                      <img [src]="articleForm.get('imagePreview')?.value || articleForm.get('imageUrl')?.value" 
                           alt="Vista previa" 
                           class="img-fluid mb-2"
                           style="max-height: 200px; width: auto;">
                      <div class="form-group mt-2">
                        <input type="text" class="form-control" 
                               placeholder="Agregar pie de imagen"
                               formControlName="imageCaption">
                      </div>
                      <button type="button" class="btn btn-sm btn-danger mt-2" (click)="removeMainImage()">
                        <i class="bi bi-trash"></i> Eliminar imagen
                      </button>
                    </div>

                    <!-- Botón de subida -->
                    <button type="button" class="btn btn-outline-primary" 
                            (click)="imageInput.click()"
                            *ngIf="!articleForm.get('imagePreview')?.value && !articleForm.get('imageUrl')?.value">
                      <i class="bi bi-upload"></i> Subir imagen
                    </button>
                  </div>
                </div>

                   <!-- Autor/Redactor -->
                <div class="form-group mb-3">
                  <label for="author" class="form-label">Autor/Redactor (opcional)</label>
                  <input type="text" id="author" class="form-control"
                    formControlName="author"
                    placeholder="Ingrese el nombre del autor o redactor">
                </div>
                
                <!-- Estado -->
                <div class="form-group mb-4">
                  <label for="articleStatus" class="form-label">Estado</label>
                  <select id="articleStatus" class="form-select" formControlName="status">
                    <option value="draft">Borrador</option>
                    <option value="published">Publicado</option>
                    <option value="scheduled">Programado</option>
                    <option value="archived">Archivado</option>
                  </select>
                </div>
                <!-- Campo para fecha/hora de publicación (solo si NO es programado) -->
                <div class="form-group mb-4" *ngIf="articleForm.get('status')?.value !== 'scheduled'">
                  <label for="publishDate" class="form-label">Fecha y hora de publicación</label>
                  <input type="datetime-local" id="publishDate" class="form-control"
                    [ngClass]="{'is-invalid': articleForm.get('publishDate')?.invalid && articleForm.get('publishDate')?.touched}"
                    formControlName="publishDate">
                  <div class="invalid-feedback"
                       *ngIf="articleForm.get('publishDate')?.errors?.['required'] && articleForm.get('publishDate')?.touched">
                    La fecha de publicación es requerida.
                  </div>
                </div>
                <!-- Mostrar fecha de creación real si existe -->
                <div class="form-group mb-4" *ngIf="currentArticle?.createdAt">
                  <label class="form-label">Fecha de creación real</label>
                  <div class="form-control-plaintext">
                    {{ getCreatedAtFormatted() }}
                  </div>
                </div>

                <!-- Campo para fecha de publicación programada (condicional) -->
                <div class="form-group mb-4" *ngIf="articleForm.get('status')?.value === 'scheduled'">
                  <label for="scheduledPublishDate" class="form-label">Fecha de Programación</label>
                  <input type="datetime-local" id="scheduledPublishDate" class="form-control"
                    [ngClass]="{'is-invalid': articleForm.get('scheduledPublishDate')?.invalid && articleForm.get('scheduledPublishDate')?.touched}"
                    formControlName="scheduledPublishDate">
                  <div class="invalid-feedback"
                       *ngIf="articleForm.get('scheduledPublishDate')?.errors?.['required'] && articleForm.get('scheduledPublishDate')?.touched">
                    La fecha de programación es requerida cuando el estado es 'Programado'.
                  </div>
                </div>

                <!-- Categoría -->
                <div class="form-group mb-3">
                  <label for="category" class="form-label">Categoría principal</label>
                  <select id="category" class="form-select" formControlName="category">
                    <option value="">Seleccionar categoría</option>
                    <option *ngFor="let category of availableCategories" [value]="category.id">
                      {{ category.name }}
                    </option>
                  </select>
                  <div class="invalid-feedback"
                    *ngIf="articleForm.get('category')?.errors?.['required'] && articleForm.get('category')?.touched">
                    La categoría es requerida
                  </div>
                  <!-- Información sobre categorías disponibles -->
                  <small class="form-text text-muted" *ngIf="currentUser?.role === 'general_editor'">
                    <i class="bi bi-info-circle"></i>
                    Puedes gestionar todas las categorías excepto "Ciudad" (reservada para editores de ciudad).
                  </small>
                  <small class="form-text text-muted" *ngIf="currentUser?.role === 'editor'">
                    <i class="bi bi-info-circle"></i>
                    Solo puedes gestionar la categoría "Ciudad" para tu ciudad asignada.
                  </small>
                </div>

                <!-- Subcategoría -->
                <div class="form-group mb-3">
                  <label for="subcategory" class="form-label">Subcategoría</label>
                  <input id="subcategory" type="text" class="form-control" formControlName="subcategory" placeholder="Ej. subtema o sección específica" />
                </div>

                <!-- Noticia destacada -->
                <div class="form-check mb-3">
                  <input class="form-check-input" type="checkbox" id="featured" formControlName="featured">
                  <label class="form-check-label" for="featured">
                    Marcar como noticia destacada
                  </label>
                </div>

                <!-- Tags -->
                <div class="form-group mb-4">
                  <label class="form-label">Etiquetas</label>
                  <tag-input formControlName="tags" [modelAsStrings]="true" [editable]="true" [maxItems]="10"
                    [placeholder]="'+ Etiqueta'" [secondaryPlaceholder]="'Agregar etiqueta'" [identifyBy]="'text'"
                    [displayBy]="'text'">
                  </tag-input>
                </div>

                <!-- Inputs ocultos para carga de imágenes -->
                <input #contentImageInput type="file" (change)="onContentImageSelected($event)" accept="image/*"
                  style="display: none">
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Modal para crear enlaces -->
  <div class="modal" [class.d-block]="showLinkDialog" [class.show]="showLinkDialog" id="linkModal" tabindex="-1"
    role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Crear enlace</h5>
          <button type="button" class="btn-close" (click)="closeLinkDialog()"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label">Texto seleccionado:</label>
            <p class="form-control-plaintext border rounded p-2 bg-light">{{ selectedText }}</p>
          </div>
          <div class="form-group">
            <label for="linkUrl" class="form-label">URL del enlace</label>
            <input type="text" class="form-control" id="linkUrl" [(ngModel)]="linkUrl"
              placeholder="https://ejemplo.com">
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeLinkDialog()">Cancelar</button>
          <button type="button" class="btn btn-primary" (click)="applyLink()">Aplicar</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Backdrop del modal -->
  <div class="modal-backdrop fade show" *ngIf="showLinkDialog"></div>
</div>